import Vue from 'vue'

import axios from 'axios';
window.axios = axios;
import { EventBus } from './components/eventBus.js';

Vue.component('vue-pagination', require('./components/general/Paginate.vue').default);

Vue.component('notification', require('./components/general/Notification.vue').default);

//#PRODUCT
Vue.component('product-images', require('./components/product/ProductImages.vue').default);
Vue.component('product-images-single', require('./components/product/ProductImagesSingle.vue').default);
Vue.component('product-tabs', require('./components/product/ProductTabs.vue').default);

//#CATEGORY
Vue.component('category-products', require('./components/category/CategoryProducts.vue').default);
Vue.component('category-select', require('./components/category/CategorySelect.vue').default);
Vue.component('category-product', require('./components/category/CategoryProduct.vue').default);
Vue.component('category-product-mobile', require('./components/category/CategoryProductMobile.vue').default);
Vue.component('category-filter', require('./components/category/CategoryFilter.vue').default);
Vue.component('category-banner', require('./components/category/CategoryBanner.vue').default);
Vue.component('category-banner-mobile', require('./components/category/CategoryBannerMobile.vue').default);
Vue.component('category-quickview', require('./components/category/CategoryQuickView.vue').default);
Vue.component('category-loader', require('./components/category/CategoryLoader.vue').default);

//#SEARCH
Vue.component('search-products', require('./components/general/SearchProducts.vue').default);

//$SVG
Vue.component('arrow-icon', require('./components/svg/ArrowIcon.vue').default);
Vue.component('filter-icon', require('./components/svg/FilterIcon.vue').default);
Vue.component('sort-icon', require('./components/svg/SortIcon.vue').default);
Vue.component('heart-icon', require('./components/svg/HeartIcon.vue').default);
Vue.component('magnify-icon', require('./components/svg/MagnifyIcon.vue').default);
Vue.component('location-icon', require('./components/svg/LocationIcon.vue').default);
Vue.component('handbag-icon', require('./components/svg/Handbag.vue').default);

//#CART
Vue.component('add-to-cart', require('./components/general/AddToCart.vue').default);
Vue.component('side-cart', require('./components/general/SideCart.vue').default);
Vue.component('remove-icon', require('./components/svg/RemoveIcon.vue').default);
Vue.component('close-icon', require('./components/svg/CloseIcon.vue').default);
Vue.component('mini-cart', require('./components/general/MiniCart.vue').default);

//#CHECKOUT
Vue.component('checkout-products-table', require('./components/general/CheckoutProductsTable.vue').default);
Vue.component('checkout-prices-table', require('./components/general/CheckoutPricesTable.vue').default);

//#WISHLIST
Vue.component('add-to-wishlist', require('./components/general/AddToWishlist.vue').default);
Vue.component('wishlist', require('./components/general/Wishlist.vue').default);
Vue.component('mini-wishlist', require('./components/general/MiniWishlist.vue').default);

Vue.component('product-cart-items', require('./components/product/ProductCartItems.vue').default);

import { store } from './store/main.js';
import { router } from './routes/routes.js';
import Toast from './packages/toast';


Vue.use(Toast);

const app = new Vue({
  el: '#app',
  store,
  router
});
